require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-budgeting-breakdown-how-to-create-and-maintain-a-budget-that-works.json") })
        }
      }, "path---es-articles-budgeting-breakdown-how-to-create-and-maintain-a-budget-that-works");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-budgeting-breakdown-how-to-create-and-maintain-a-budget-that-works!./.cache/json/es-articles-budgeting-breakdown-how-to-create-and-maintain-a-budget-that-works.json
// module id = 2039
// module chunks = 231608221292675